// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'users';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.89 6.078a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0zm-1.859 8.766a4.781 4.781 0 0 1 9.563 0m.072-7.172a2.39 2.39 0 1 0 4.781 0 2.39 2.39 0 0 0-4.781 0zm1.034 3.501a3.914 3.914 0 0 1 5.269 3.67'
  />
);

export const viewBox = '0 0 18 18';
